import constants from 'common/constants'

import {
  ASSIGN_SUBJECT_TEACHERS,
  COPY_SUBSECTION,
  CREATE_SUBJECT,
  CREATE_SUBSECTIONS,
  DELETE_MANY_SUBSECTION,
  DELETE_SUBSECTION,
  GENERATE_OVERALL_SUBJECT_REPORT,
  GENERATE_STUDENT_LIST,
  GET_EXCLUDE_SUBSECTIONS,
  GET_PREVIOUS_SUBJECTS,
  GET_STUDENTS_SUBJECTS_NEW,
  GET_SUBJECT,
  GET_SUBJECTS,
  GET_SUBJECTS_STUDENTS,
  GET_SUBJECT_EXAMS,
  GET_SUBJECT_SEQUENCE,
  GET_SUBSECTION,
  GET_SUBSECTIONS,
  GET_SYLLABUS_SUBJECTS,
  LOCK_SELECTED_OUTLINE,
  SET_SUBJECT_WEIGHTAGE,
  STUDENT_SUBJECT_REPORT,
  UNLOCK_SELECTED_OUTLINE,
  UPDATE_EXCLUDE_SUBSECTION,
  UPDATE_SUBJECTS,
  UPDATE_SUBJECT_SEQUENCE,
  UPDATE_SUBSECTION,
} from './ActionTypes/ApiActionTypes'
import {REDUX_GET_USER_SUBJECTS} from './ActionTypes/ReduxActionTypes'

export const getSubjects = (data, onSuccess, onFailure, reduxUpdate = false) => {
  return {
    type: GET_SUBJECTS,
    payload: {
      apiUrl: constants.api_get_subjects,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: reduxUpdate ? REDUX_GET_USER_SUBJECTS : '',
      onSuccess,
      onFailure,
    },
  }
}

export const getSubject = (id, onSuccess, onFailure) => {
  return {
    type: GET_SUBJECT,
    payload: {
      apiUrl: constants.api_get_subject(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getSubjectsStudents = (data, onSuccess, onFailure) => {
  return {
    type: GET_SUBJECTS_STUDENTS,
    payload: {
      apiUrl: constants.api_post_student_subjects,
      getString: '',
      useBaseURL: true,
      body: data,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const addSubject = (body, onSuccess, onFailure) => {
  return {
    type: CREATE_SUBJECT,
    payload: {
      apiUrl: constants.api_add_subject,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const updateSubject = (id, data, onSuccess, onFailure) => {
  return {
    type: UPDATE_SUBJECTS,
    payload: {
      apiUrl: constants.api_update_subject(id),
      getString: '',
      body: data,
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const updateSubjectSequence = (data, onSuccess, onFailure) => {
  return {
    type: UPDATE_SUBJECT_SEQUENCE,
    payload: {
      apiUrl: constants.api_update_subject_sequence,
      getString: '',
      body: data,
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getSubjectSequence = (data, onSuccess, onFailure) => {
  return {
    type: GET_SUBJECT_SEQUENCE,
    payload: {
      apiUrl: constants.api_get_subject_sequence,
      getString: '',
      body: data,
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const generateStudentList = (body, onSuccess, onFailure) => {
  return {
    type: GENERATE_STUDENT_LIST,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_generate_student_list,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}
export const generateOverallSubjectReport = (body, onSuccess, onFailure) => {
  return {
    type: GENERATE_OVERALL_SUBJECT_REPORT,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_generate_overall_subject_report,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}
export const setSubjectWeighatge = (id, body, onSuccess, onFailure) => {
  return {
    type: SET_SUBJECT_WEIGHTAGE,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_set_subject_weightage(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}
export const generateStudentSubjectReport = (body, onSuccess, onFailure) => {
  return {
    type: STUDENT_SUBJECT_REPORT,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_generate_student_subject_report,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}
export const lockSelectedOutline = (body, onSuccess, onFailure) => {
  return {
    type: LOCK_SELECTED_OUTLINE,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_lock_selected_outline,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}
export const unlockSelectedOutline = (body, onSuccess, onFailure) => {
  return {
    type: UNLOCK_SELECTED_OUTLINE,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_unlock_selected_outline,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}

export const getPreviousSubjects = (data, onSuccess, onFailure) => {
  return {
    type: GET_PREVIOUS_SUBJECTS,
    payload: {
      apiUrl: constants.api_get_previous_subjects,
      getString: '',
      useBaseURL: true,
      body: data,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getSubjectExams = (data, onSuccess, onFailure) => {
  return {
    type: GET_SUBJECT_EXAMS,
    payload: {
      apiUrl: constants.api_get_subject_exam,
      getString: '',
      useBaseURL: true,
      body: data,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const assignSubjectTeachers = (data, onSuccess, onFailure) => {
  return {
    type: ASSIGN_SUBJECT_TEACHERS,
    payload: {
      apiUrl: constants.api_assign_subject_teachers,
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getSubsections = (data, onSuccess, onFailure) => {
  return {
    type: GET_SUBSECTIONS,
    payload: {
      apiUrl: constants.api_get_subjects_subsections,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const addSubsection = (body, onSuccess, onFailure) => {
  return {
    type: CREATE_SUBSECTIONS,
    payload: {
      apiUrl: constants.api_add_subject_subsection,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const updateSubsection = (id, data, onSuccess, onFailure) => {
  return {
    type: UPDATE_SUBSECTION,
    payload: {
      apiUrl: constants.api_update_subject_subsection(id),
      getString: '',
      body: data,
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getSubsection = (id, onSuccess, onFailure) => {
  return {
    type: GET_SUBSECTION,
    payload: {
      apiUrl: constants.api_get_subject_subsection(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const deleteSubsection = (id, onSuccess, onFailure) => {
  return {
    type: DELETE_SUBSECTION,
    payload: {
      apiUrl: constants.api_delete_subject_subsection(id),
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const deleteManySubsections = (ids, onSuccess, onFailure) => {
  return {
    type: DELETE_MANY_SUBSECTION,
    payload: {
      apiUrl: constants.api_delete_many_subject_subsections,
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      body: {ids: ids},
      onSuccess,
      onFailure,
    },
  }
}

export const getExcludeSubsections = (id, body, onSuccess, onFailure) => {
  return {
    type: GET_EXCLUDE_SUBSECTIONS,
    payload: {
      apiUrl: constants.api_get_exclude_subsections(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: body,
      onSuccess,
      onFailure,
    },
  }
}

export const updateExcludeSubsections = (body, onSuccess, onFailure) => {
  return {
    type: UPDATE_EXCLUDE_SUBSECTION,
    payload: {
      apiUrl: constants.api_update_exclude_subsection,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const copySubsections = (body, onSuccess, onFailure) => {
  return {
    type: COPY_SUBSECTION,
    payload: {
      apiUrl: constants.api_copy_subsection,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getSyllabusSubjects = (body, onSuccess, onFailure) => {
  return {
    type: GET_SYLLABUS_SUBJECTS,
    payload: {
      apiUrl: constants.api_get_syllabus_subjects,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const getStudentSubjectsNew = (data, onSuccess, onFailure) => {
  return {
    type: GET_STUDENTS_SUBJECTS_NEW,
    payload: {
      apiUrl: 'subjects/student-subjects',
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}
